import { render, staticRenderFns } from "./trafficBanner.vue?vue&type=template&id=3b865b64&scoped=true"
import script from "./trafficBanner.vue?vue&type=script&lang=js"
export * from "./trafficBanner.vue?vue&type=script&lang=js"
import style0 from "./trafficBanner.vue?vue&type=style&index=0&id=3b865b64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b865b64",
  null
  
)

export default component.exports